module.exports = __webpack_public_path__ + "static/podpis.b35b6244.jpg";